import { render, staticRenderFns } from "./myLoan.vue?vue&type=template&id=2cd066e0&scoped=true"
import script from "./myLoan.vue?vue&type=script&lang=js"
export * from "./myLoan.vue?vue&type=script&lang=js"
import style0 from "./myLoan.vue?vue&type=style&index=0&id=2cd066e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd066e0",
  null
  
)

export default component.exports